import classes from "../classes";
import { FormattedPayout } from "./formatted-currency";
import { hasPayout } from "../payouts";
import pure from "./higher-order/pure";
import React from "react";
import { ordinal } from "../ordinal";

export default pure(function TableHeaderTicket({ isLarge, showScore, ticket, tokenTypes }) {
  var rank = ticket.get("rank");
  var place = ordinal(rank);
  var tooltip = "Ticket #" + ticket.get("ticket_number") + " is in " + place + " place! Score: " + ticket.get("score") + ".";

  var payout;
  if (hasPayout(ticket)) {
    payout = <FormattedPayout size="small" ticket={ticket} tokenTypes={tokenTypes} />;
  }

  var eliminated = ticket.get("eliminated_by_race_id");

  var score;
  if (showScore) {
    score = (
      <span className={classes({
        "tickets_score": true,
        "tickets_score--points": parseFloat(ticket.get("score")) > 0.0
      })}>
        {ticket.get("score")}
      </span>
    );
  }

  return (
    <div
      className={classes({
        "game-table_cell": true,
        "game-table_cell--ticket": !isLarge,
        "text-center": true,
        "tooltip": true
      })}
      data-tooltip={tooltip}>
      <div className={classes({
        "tickets_item": true,
        "tickets_item--is-eliminated": eliminated,
        "tickets_item--is-large": isLarge,
        "tickets_item--is-winner": payout && !eliminated
      })}>
        <span className="tickets_prize">
          {payout}
        </span>

        <span className="tickets_number">
          {ticket.get("ticket_number")}
        </span>

        <span className="tickets_rank">
          <span>
            Rank
          </span>

          {" "}

          {rank}
        </span>
      </div>

      {score}
    </div>
  );
});
